/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Builds a locations page redirect URL from a locations home prefix and one or
 * more path segments (e.g. state, city).
 *
 * Segments are percent-encoded so locales with special characters (MX/BR, e.g.
 * `estado-de-méxico`) produce a valid UTF-8 URL when written to an HTTP
 * `Location` header — otherwise raw characters are mis-encoded as Latin-1
 * (`é` -> `%E9`) and the redirect target no longer matches a real page.
 *
 * The `.html` suffix matches the canonical locations URL format.
 */
export const getLocationsRedirectUrl = (locationsHome: string, ...segments: string[]) =>
  `/${[locationsHome, ...segments.map(encodeURIComponent)].join('/')}.html`;
